export default "__VITE_ASSET__BvUec9SL__"